export const UserType = {
    MENTOR : 'Mentor',
    SUPPORTER: 'Supporter',
    ADMIN: 'Admin'
}

export const HttpMethod = {
    GET : 'GET',
    PUT : 'PUT',
    POST : 'POST',
    DELETE : 'DELETE'
  }